import { useState, useEffect } from "react";
import axios from "axios";
import { ChevronDown, ChevronUp, HelpCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FaqsSection() {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/faqs`)
      .then(res => setFaqs(res.data))
      .catch(() => setFaqs([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || faqs.length === 0) return null;

  return (
    <section id="faqs" className="py-14 md:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 bg-[#0072A4]/10 rounded-full px-5 py-2 mb-5">
            <HelpCircle size={16} color="#0072A4" />
            <span className="text-[#0072A4] font-['Montserrat'] font-bold text-[10px] uppercase tracking-[0.18em]">Preguntas Frecuentes</span>
          </div>
          <h2
            className="font-['Montserrat'] font-extrabold text-[#0F172A] mb-5"
            style={{ fontSize: "clamp(1.25rem, 1.8vw, 1.625rem)", letterSpacing: "-0.01em", lineHeight: 1.2 }}
            data-testid="faqs-title"
          >
            Todo lo que necesitas saber
          </h2>
          <p className="font-['Montserrat'] font-medium text-[#475569] text-sm md:text-base max-w-xl mx-auto">
            Resolvemos tus dudas sobre el Campus Verano Activo La Estanca 2026
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={faq._id || i}
              data-testid={`faq-item-${i}`}
              className="border border-[#E2E8F0] rounded-2xl overflow-hidden transition-all duration-200 hover:border-[#0072A4]/40 hover:shadow-sm"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                data-testid={`faq-toggle-${i}`}
                className="w-full flex items-center justify-between px-7 py-6 text-left bg-white hover:bg-[#F0F8FF] transition-colors"
              >
                <span className="font-['Montserrat'] font-bold text-[#0F172A] text-[0.9375rem] pr-4 leading-snug">
                  {faq.pregunta}
                </span>
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#0072A4]/10 flex items-center justify-center">
                  {openIndex === i
                    ? <ChevronUp size={16} color="#0072A4" />
                    : <ChevronDown size={16} color="#0072A4" />
                  }
                </span>
              </button>

              {openIndex === i && (
                <div
                  className="px-7 pb-7 pt-2 bg-[#F8FAFC] border-t border-[#E2E8F0]"
                  data-testid={`faq-answer-${i}`}
                >
                  <p className="font-['Montserrat'] text-[#475569] text-sm leading-relaxed">
                    {faq.respuesta}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <p className="font-['Montserrat'] text-[#475569] text-sm mb-5">
            ¿Tienes otra pregunta? Contacta con nosotros directamente.
          </p>
          <a
            href="#inscripcion"
            data-testid="faqs-register-cta"
            className="inline-flex items-center gap-2 bg-[#0072A4] text-white font-['Montserrat'] font-bold px-10 py-4 rounded-full hover:bg-[#005A80] active:scale-95 transition-all shadow-lg"
          >
            Inscribirme ahora
          </a>
        </div>
      </div>
    </section>
  );
}
